import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { GenericDialog, Button } from '@/common'

export default function ProductionRouteDeleteDialog({
  name,
  isOpen,
  close,
  onDelete,
  isDeleting
}: {
  name: string
  isOpen: boolean
  close: () => void
  onDelete: () => void
  isDeleting: boolean
}) {
  const { t } = useTranslation()

  const onClose = () => {
    close()
  }

  const onDeleteClick = useCallback(() => {
    onDelete()
    close()
  }, [onDelete, close])

  return (
    <GenericDialog
      size="md"
      title={t('productionRoute:deleteDialog.title')}
      isOpen={isOpen}
      close={onClose}
    >
      <div className="space-y-6 text-center">
        <p>{t('productionRoute:deleteDialog.description', { name })}</p>
        <footer className="gap-2 flex justify-end">
          <Button variant="neutral" disabled={isDeleting} onClick={onClose}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            onClick={onDeleteClick}
            variant="danger"
            disabled={isDeleting}
            isLoading={isDeleting}
          >
            {t('common:actions.delete')}
          </Button>
        </footer>
      </div>
    </GenericDialog>
  )
}
